export const DEAL_RENT_MENU_ITEM_TITLE_EXPERIMENT_NAME = 'deal_rent_menu_item_title_experiment';
export const DEAL_RENT_MENU_ITEM_RENAME = 'deal_rent_header_menu_item_rename';
export const DEAL_RENT_HEADER_BANNER = 'deal_rent_header_banner';
export const DEAL_RENT_HEADER_NEW_ITEM = 'deal_rent_head_new_item';

export const EXPERIMENTS = [
  DEAL_RENT_MENU_ITEM_TITLE_EXPERIMENT_NAME,
  DEAL_RENT_HEADER_BANNER,
  DEAL_RENT_HEADER_NEW_ITEM,
  DEAL_RENT_MENU_ITEM_RENAME,
];
